import { useMemo } from 'react';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { fetchKpiHeatmapCustomerView } from './kpiDashboardApi';

const STALE_MS = 60_000;
const GC_MS = 10 * 60_000;

export function useKpiHeatmapCustomerView(
  filterKey: string,
  filterValues: Record<string, string | string[]>,
  options: { enabled: boolean }
) {
  const timezoneOffset = useMemo(() => new Date().getTimezoneOffset(), []);

  return useQuery({
    queryKey: ['kpi-heatmap-customer', filterKey],
    queryFn: () => fetchKpiHeatmapCustomerView(filterValues, timezoneOffset),
    enabled: options.enabled,
    staleTime: STALE_MS,
    gcTime: GC_MS,
    placeholderData: keepPreviousData,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
